export default __webpack_public_path__ + "static/media/img-video-press-release-new.0eb6e67d.png";